import React, { useEffect, useState } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';

// ASSETS
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBuilding, faFile, faDownload, faChevronRight, faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import { useMainContext } from "../../../../contexts/MainContext";

// COMPONNENTS
import SortHeader from "../../../../components/atoms/SortHeader";
import InputCheckboxList from '../../../../components/atoms/InputCheckboxList';

const TableTemplates = ({ openDeletModal, openDownload }) => {
    const [selectedStates, setSelectedStates] = useState([]);
    const [showModal, setShowModal] = useState(false);
    let mainContext = useMainContext();

    const closeModal = () => {
        setShowModal(false)
        mainContext.setIsLoading(false);
    }


    // 🔥 FILAS QUEMADAS
    const staticRows = [
        {
            id: "IMP0001",
            nameTemplate: "La Nacional",
            UltimaFechaUso: "Uso Mixto",
            UltimaFechaUso: "21/02/2025",
            dueno: "Camilo Blanco",
            tipo: "México",
            downloadTool: "Monterrey",
            downloadTemplates: "Activo"
        },
        {
            id: "IMP0002",
            nameTemplate: "The Crown Cantera",
            UltimaFechaUso: "The Crown Cantera",
            UltimaFechaUso: "21/02/2025",
            dueno: "Nathalia G",
            tipo: "México",
            downloadTool: "Ciudad de México",
            downloadTemplates: "Activo"
        },
        {
            id: "IMP0003",
            nameTemplate: "Palmez",
            UltimaFechaUso: "Palmez",
            UltimaFechaUso: "21/02/2025",
            dueno: "Arturo P",
            tipo: "México",
            downloadTool: "Querétaro",
            downloadTemplates: "Activo"
        }
    ];

    const handleStateChange = (paramName, value) => {
        setSelectedStates(value);
    };

    const myCatalog = [
        { countryID: 1, countryName: "" }
    ];


    const buildingTemplate = (rowData) => {
        return (
            <button className="iconButton">
                <FontAwesomeIcon icon={faBuilding} />
            </button>
        );
    };
    const fileLinesTemplate = (rowData) => {
        return (
            <button className="iconButton">
                <FontAwesomeIcon icon={faFile} />
            </button>
        );
    };
    const downloadTemplate = (rowData) => {
        return (
            <button className="iconButton">
                <FontAwesomeIcon icon={faDownload} />
            </button>
        );
    };
    return (
        <div className="datatable-responsive-demo mt-4 tableImporters">
            <DataTable
                value={staticRows}
                className="p-datatable-striped"
                tableStyle={{ 'table-layout': 'auto' }}
                emptyMessage="No se encontraron datos"
            >
                <Column field="id" header={<SortHeader label="ID" />} />
                <Column field="nameTemplate" header={<SortHeader label="Nombre de Plantilla" />}
                    body={(row) => <a className="anchorBlue">{row.nameTemplate}</a>}
                />
                <Column field="UltimaFechaUso" header={<SortHeader label="Ultima fecha de uso" />}/>
                <Column field="dueno" header="Dueño"/>
                <Column field="gyre" header="Giro"/>
                <Column field="relatedInitiatives" header="Inicitativas Vinculadas" body={buildingTemplate} />
                <Column field="downloadTool" header="Descarga de Herramienta" body={fileLinesTemplate} />
                <Column field="downloadTemplates" header="Descarga de Plantilla" body={downloadTemplate} />
            </DataTable>
            <div className="mt-4 text-right">
                <button className="btn">
                    <FontAwesomeIcon icon={faChevronLeft} />
                </button>
                <button className="btn">
                    <FontAwesomeIcon icon={faChevronRight} />
                </button>
            </div>
        </div>
    );
}

export default TableTemplates;